import React from 'react';
import { useLanguage, LanguageContext } from './hooks/useLanguage';
import { useLenis } from './hooks/useLenis';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Projects from './components/Projects';
import Process from './components/Process';
import Energy from './components/Energy';

import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';

const Divider = () => (
  <div style={{ height: '1px', background: 'linear-gradient(90deg, #C8A96E, transparent)' }} />
);

const WhatsAppButton = () => (
  <a
    href="https://wa.me/34936943568"
    target="_blank"
    rel="noreferrer"
    title="WhatsApp"
    style={{
      position: 'fixed',
      bottom: '28px',
      left: '28px',
      zIndex: 999,
      width: '52px',
      height: '52px',
      background: '#0D0D0D',
      border: '1px solid #C8A96E',
      color: '#C8A96E',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.2s, color 0.2s',
    }}
    onMouseEnter={(e) => {
      (e.currentTarget as HTMLAnchorElement).style.background = '#C8A96E';
      (e.currentTarget as HTMLAnchorElement).style.color = '#0D0D0D';
    }}
    onMouseLeave={(e) => {
      (e.currentTarget as HTMLAnchorElement).style.background = '#0D0D0D';
      (e.currentTarget as HTMLAnchorElement).style.color = '#C8A96E';
    }}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.122.554 4.112 1.524 5.837L.057 23.22a.75.75 0 00.922.922l5.383-1.467A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.725 9.725 0 01-4.963-1.357l-.357-.213-3.697 1.008 1.008-3.697-.213-.357A9.725 9.725 0 012.25 12c0-5.376 4.374-9.75 9.75-9.75S21.75 6.624 21.75 12 17.376 21.75 12 21.75z"/>
    </svg>
  </a>
);

const App: React.FC = () => {
  const { lang, setLang } = useLanguage();
  useLenis();

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      <div style={{ background: '#0D0D0D' }}>
        <Header />
        <main>
          <Hero />
          <Divider />
          <Services />
          <Projects />
          <Energy />
          <Divider />
          <Process />
          <Divider />
          <About />
          <Divider />
          <FAQ />
          <Divider />
          <Contact />
        </main>
        <Divider />
        <Footer />
        <Chatbot />
        <WhatsAppButton />
      </div>
    </LanguageContext.Provider>
  );
};

export default App;
